import Cookies from 'js-cookie'

const TokenKey = 'CWEB-TICKETID'
const SecretKey = 'cweb-login-secret-key'
const userName = 'user_name'

export function getToken () {
  const token = Cookies.get(TokenKey)
  if (token && token !== undefined) {
    return token
  } else {
    return ''
  }
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getSecret () {
  const secret = Cookies.get(SecretKey)
  if (secret && secret !== undefined) {
    return secret
  } else {
    return ''
  }
}

export function setSecret (secret) {
  return Cookies.set(SecretKey, secret)
}

export function removeSecret () {
  return Cookies.remove(SecretKey)
}

export function getName () {
  const name = Cookies.get(userName)
  if (name && name !== undefined) {
    return name
  } else {
    return ''
  }
}

export function setName (name) {
  return Cookies.set(userName, name)
}

export function removeName () {
  return Cookies.remove(userName)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js